import { useMemo, useState } from 'react';
import { useGetShellsQuery } from '../../utils/callApis';
import { useSelector, RootStateOrAny } from 'react-redux';
import { Box } from '@mui/material';
import ShellExcerpt from './ShellExcerpt';
import CircularProgress from '@mui/material/CircularProgress';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';

export const ShellsList = () => {
    const { data: shells, isLoading, isSuccess, isError, error } = useGetShellsQuery("shells");
    const [selected, setSelected] = useState(null);
    const shell = useSelector((state: RootStateOrAny) => state.rootReducer.currentShell);
    const currentSide = useSelector((state: RootStateOrAny) => state.rootReducer.settingsOptions.currentSide);
    const displayName = useMemo(() => {
        const currentShell = shell[currentSide === 'both' ? 'leftShell' : currentSide + 'Shell'];
        return currentShell.displayName;
    }, [currentSide, shell]);

    let content;

    if (isLoading) {
        content = (
            <Box className={layout.loaderContainer}>
                <CircularProgress />
            </Box>
        );
    } else if (isSuccess) {
        let shellsPicker = shells.map((shell, index) => (
            <ShellExcerpt
                key={index}
                setSelected={setSelected}
                shell={shell}
                isCurrent={shell.displayName === displayName}
                currentSide={currentSide}
            />
        ));
        content = (
            <>
                <h4 className={typography.headerTitle}>
                    {selected !== null ? selected : displayName}
                </h4>
                <Box className={layout.sliderContainer}>{shellsPicker}</Box>
            </>
        );
    } else if (isError) {
        content = <div>{error.toString()}</div>;
    }

    return <Box className={layout.excerptContainer}>{content}</Box>;
};
